import { render, staticRenderFns } from "./BudgetAccountEditDialog.vue?vue&type=template&id=792916e4"
import script from "./BudgetAccountEditDialog.vue?vue&type=script&lang=js"
export * from "./BudgetAccountEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports